import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import defaultBgImage from "assets/images/office2.jpg";

function PageHero({ title, subtitle, bgImage, children }) {
  const image = bgImage || defaultBgImage;
  return (
    <>
      <MKBox
        minHeight="70vh"
        width="100%"
        sx={{ position: "relative", display: "grid", placeItems: "center" }}
      >
        <MKBox
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${image})`,
            backgroundSize: "cover",
            backgroundPosition: "bottom",
            zIndex: -1,
          }}
        />
        <MKBox
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 0,
          }}
        />
        <Container sx={{ position: "relative", zIndex: 1 }}>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography variant="h1" color="white" textAlign="center" mt={-6} mb={1}>
              {title}
            </MKTypography>
            {subtitle && (
              <MKTypography
                variant="body1"
                color="white"
                textAlign="center"
                px={{ xs: 2, lg: 4 }}
                mt={1}
                sx={{ overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}
              >
                {subtitle}
              </MKTypography>
            )}
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          pb: 20,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        {children}
      </Card>
    </>
  );
}

PageHero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  bgImage: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default PageHero;
